import { NotFound } from '~/pages/not-found'

export default NotFound
